<div 
  class="relative flex items-center justify-center py-2 transition-colors last:border-r-0 z-20 border-t border-t-gray-200 border-b border-b-gray-50 font-title text-xs leading-[18px] font-medium" 
  [ngClass]=" {
                'bg-gray-50': !isDisabled(),
                'bg-gray-100/80': isDisabled(),
                'shadow shadow-black/10': !isDisabled(),
                'text-gray-400': isDisabled(),
                'text-gray-500': !isDisabled()
              }"
  >
  <!-- @if (isCurrentMonth()) { -->
    {{ isToday() ? "Hoy" : day().getDate() }}
  <!-- } -->
</div>
<div 
  class="relative flex items-center justify-center transition-colors px-px py-2.5 z-10" 
  [ngClass]=" {
                'bg-white': !isDisabled(),
                'bg-gray-50': isDisabled()
              }">
  <lib-time-picker [minutesSeconds]="false" [maxHours]="24" [formControl]="control()">

  </lib-time-picker>
</div>